import React from 'react';
import WholesalePartsHubHeader from '../wholesale-parts-hub-header';
import WholesalePartsHubSection from '../wholesale-parts-hub-section';
import Button from '../../button';
import Link from '../../link';

interface Props {
  id: string;
}

const WholesalePartsHubPartsOrdering: React.FC<Props> = ({ id }) => {
  let content = <React.Fragment />;

  if (id === 'independent-repair-facility') {
    content = (
      <WholesalePartsHubSection
        title="Independent Repair Facility"
        id="independent-repair-facility"
      >
        <div className="section-grid">
          <img src={`${process.env.CDN_URL}/wholesale-parts-hub/14.png`} />
          <div>
            <p>
              <strong>Volvo RepairLink</strong>
            </p>
            <p>
              Entirely free to use, quickly find and purchase Volvo mechanical
              parts you need, at competitive prices with a simple click. The
              Volvo RepairLink Program allows for you to get great deals that
              are only available through RepairLink.
            </p>
            <p>
              Help keep your workflow efficient by ordering directly through
              RepairLink. Enjoy competitive prices and a vast selection of Volvo
              Genuine Parts.
            </p>
            <Link href="https://repairlinkshop.com/">
              <Button text="Order via RepairLink" />
            </Link>
          </div>
        </div>
        <div className="divider" />
        <div className="section-grid">
          <img src={`${process.env.CDN_URL}/wholesale-parts-hub/15.png`} />
          <div>
            <p>
              <strong>Volvo CollisionLink</strong>
            </p>
            <p>
              Quickly locate and purchase the parts needed to restore a Volvo to
              its pre-accident condition. It’s entirely free to use.
            </p>
            <p>
              Preserving the original safety and quality of a Volvo is critical
              for customer safety. Improve workshop efficiency and cycle times
              by ordering directly at discounted prices.
            </p>
            <Link href="https://www.collisionlinkshop.com/">
              <Button text="Order via CollisionLink" />
            </Link>
          </div>
        </div>
        <div className="divider" />
        <div className="section-grid">
          <img src={`${process.env.CDN_URL}/wholesale-parts-hub/16.png`} />
          <div>
            <p>
              <strong>Volvo Parts & Accessories Online Store</strong>
            </p>
            <p>
              A convenient online store allowing you to look up and purchase
              most parts or accessories right from your screen. This solution is
              perfect for those who want items shipped right to their door or
              may not be close to an authorized Volvo retailer.
            </p>
            <Link href="https://usparts.volvocars.com/">
              <Button text="Order via the Online Store" />
            </Link>
          </div>
        </div>
        {/* language=CSS */}
        <style jsx>{`
          .section-grid {
            position: relative;
            display: flex;
            align-items: flex-start;
            gap: 1rem;
          }

          .section-grid img {
            padding-top: 1rem;
            width: 200px;
            object-fit: contain;
          }

          .divider {
            margin: 3rem auto;
            height: 1px;
            background-color: #eee;
            width: 80%;
          }

          img {
            width: 200px;
          }
        `}</style>
      </WholesalePartsHubSection>
    );
  } else if (id === 'diy-customer') {
    content = (
      <WholesalePartsHubSection title="DIY Customer" id="diy-customer">
        <div className="section-grid">
          <img src={`${process.env.CDN_URL}/wholesale-parts-hub/16.png`} />
          <div>
            <p>
              <strong>Volvo Parts & Accessories Online Store</strong>
            </p>
            <p>
              A convenient online store to order Volvo Genuine Parts. Order
              replacement parts you may need for your Volvo directly from your
              computer, phone, or tablet and have them shipped directly to your
              home. Get the convenience you deserve.
            </p>
            <p>
              Looking for additional functionality? Customize your Volvo and
              make it your own. From rooftop load bars and cargo boxes to
              protective floor mats and sunshades, there’s something for
              everyone. All designed to fit and function exactly right on your
              Volvo.
            </p>
            <Link href="https://usparts.volvocars.com/">
              <Button text="Order via the Online Store" />
            </Link>
          </div>
        </div>
        {/* language=CSS */}
        <style jsx>{`
          .section-grid {
            position: relative;
            display: flex;
            align-items: flex-start;
            gap: 1rem;
          }

          @media screen and (max-width: 850px) {
            .section-grid {
              flex-wrap: wrap;
            }
          }

          .section-grid img {
            padding-top: 1rem;
            width: 200px;
            object-fit: contain;
          }

          img {
            width: 200px;
          }
        `}</style>
      </WholesalePartsHubSection>
    );
  }

  return (
    <div className="wpc-content">
      <WholesalePartsHubHeader>Wholesale Parts Hub</WholesalePartsHubHeader>
      {content}
      {/* language=CSS */}
      <style jsx>{`
        .wpc-content {
          padding: 2rem 3rem;
          font-family: 'Volvo Novum', sans-serif;
          font-size: 14px;
          min-height: 30rem;
        }

        strong {
          font-weight: 500;
        }

        .divider {
          margin: 3rem auto;
          height: 1px;
          background-color: #eee;
          width: 80%;
        }
      `}</style>
    </div>
  );
};

export default WholesalePartsHubPartsOrdering;
